import { render } from "./button.vue?vue&type=template&id=51c901e6&scoped=true&ts=true"
import script from "./button.vue?vue&type=script&lang=ts"
export * from "./button.vue?vue&type=script&lang=ts"

import "./button.vue?vue&type=style&index=0&id=51c901e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c901e6"]])

export default __exports__